import './App.css';
import './Questionnaire.css'
import { Question, Answer } from './models/Questions'
import { useState } from 'react'
import store from './store'
import QuestionPage from "./QuestionPage";
import RangeQuestion from "./RangeQuestion";
import CallMePage from './CallMePage';
import StartPage from './StartPage'
import ProgressBar from './ProgressBar';
import WhyBlocks from './WhyBlocks';
import ThankYou from './ThankYou';


function App() {
  
  const [currentIndexOfQuestion, setCurrentIndex] = useState(0);
  const [currentQuestion, setQuestion] = useState(store[currentIndexOfQuestion]);
  const [percentValue, setPercent] = useState(0 * 1 / (store.length + 1) * 100);
  const [isCallMe, setIsCallMe] = useState(false);
  const [isStartPage, setIsStartPage] = useState(true);
  const [isThankYou, setIsThankYou] = useState(false);

  const pathArray = window.location.pathname.split('/');
  const isHaveThankYouSegment = pathArray[pathArray.length - 2] == 'thanks';
  if (isThankYou) {
    if (!isHaveThankYouSegment)
      window.location.pathname += "/thanks"
    return <ThankYou />
  } else if (pathArray[pathArray.length - 2] == 'thanks') {
    setIsThankYou(true);
  }

  if (isStartPage)
    return <StartPage toSite={() => { setIsStartPage(false); }} />

  if (isCallMe)
    return <CallMePage sendedFeedback={() => { setIsThankYou(true) }} />


  store[currentIndexOfQuestion] = currentQuestion;

  const selectAnswer = (selectedAnswer: Answer) => {

    for (let a of currentQuestion.answers) {
      let selected = a == selectedAnswer;

      if (currentQuestion.multiple) {
        a.isChecked = selected ? !a.isChecked : a.isChecked;
      } else {
        a.isChecked = selected;
      }

    }

    setQuestion(new Question(currentQuestion.text, currentQuestion.answers, currentQuestion.multiple, currentQuestion.isRange));

    if (!currentQuestion.multiple) {
      setTimeout(() => toQuestionOffset(1), 200);
    }

    return false;

  };

  const toQuestionOffset = (offset: number) => {

    document.getElementsByClassName('questionnaire__question')[0].classList.add('go-left');

    setTimeout(() => {

      const newIndex = currentIndexOfQuestion + offset;

      if (newIndex < store.length) {
        setCurrentIndex(newIndex);
        setPercent(newIndex * 1 / (store.length + 1) * 100);
        setQuestion(new Question(store[newIndex].text, store[newIndex].answers, store[newIndex].multiple, store[newIndex].isRange));
      } else {
        setIsCallMe(true);
      }

      document.getElementsByClassName('questionnaire__question')[0].classList.remove('go-left');

    }, 600)

  };

  let page = currentQuestion.isRange ?
   (<RangeQuestion question={currentQuestion} selectAnswer={selectAnswer} />) : 
   (<QuestionPage question={currentQuestion} selectAnswer={selectAnswer} />)

  return (
    <div className="App quiz">
      <div className="questionnaire">
        {page}
        <div className="questionnaire__navbar">
          <div className='questionnaire__navbar--container'>
            <ProgressBar percentValue={percentValue} />
            <div className="questionnaire-navbar__buttons">
              <button disabled={currentIndexOfQuestion == 0} onClick={() => toQuestionOffset(-1)} className="button is-link questionnaire-navbar__button questionnaire-navbar__button_prev">
                <span className="icon">
                  <svg viewBox="0 0 24 24" className="mdi-icon mdi-24px">
                    <title>mdi-arrow-left</title>
                    <path d="M20,11V13H8L13.5,18.5L12.08,19.92L4.16,12L12.08,4.08L13.5,5.5L8,11H20Z" stroke-width="0" fill-rule="nonzero"></path>
                  </svg>
                </span>
              </button>
              <button disabled={!currentQuestion.answers.find(a => a.isChecked) && !currentQuestion.isRange} onClick={() => toQuestionOffset(1)} className="button is-blicked questionnaire-navbar__button questionnaire-navbar__button_next">
                <span className="questionnaire-navbar__button_next-text">Далее</span>
                <span className="icon questionnaire-navbar__next-icon">
                  <svg viewBox="0 0 24 24" className="mdi-icon mdi-24px">
                    <title>mdi-arrow-right</title>
                    <path d="M4,11V13H16L10.5,18.5L11.92,19.92L19.84,12L11.92,4.08L10.5,5.5L16,11H4Z" stroke-width="0" fill-rule="nonzero"></path>
                  </svg>
                </span>
              </button>
            </div>
            <span className="questionnaire-navbar__hint">или нажмите
              <b>Enter</b></span>
          </div>
        </div>
      </div>
      <div className="why-us">
        <div className="discount">
          <div className="text-block left">Ваша скидка</div>
          <div className="text-block right">20%</div>
        </div>
        <div className="call-me-page__block">
          <div className="call-me-page__block-content">
            <WhyBlocks />
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;

